import invoiceQueries from "$/lib/queries/invoice-queries"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const paramsSchema = z.object({
  companyId: z.guid(),
  invoiceNumber: z.coerce.number<number>().int().min(1),
})

export const Route = createFileRoute(
  "/(app)/_auth/companies/$companyId/fakturor/$invoiceNumber",
)({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ companyId, invoiceNumber }) => ({
      companyId: `${companyId}`,
      invoiceNumber: `${invoiceNumber}`,
    }),
  },
  loader: async ({ context: { queryClient }, params }) => {
    const invoice = await queryClient.fetchQuery(
      invoiceQueries.byCompanyAndNumber(params.companyId, params.invoiceNumber),
    )
    return {
      crumbs: [
        "alfred.pages.companies.crumbs.overview",
        "alfred.pages.companies.crumbs.companyJobs",
        `Faktura ${invoice.displayNumber}`,
      ],
      froms: ["/", "/", undefined],
    }
  },
})
